module.exports = __webpack_public_path__ + "img/text.dcdcb7dd.svg";